const ListingActivationConstants = {
  ERROR_CODE: {
    INVALID_FIELDS: 'listingActivationInvalidFields',
    LISTING_BLOCKED: 'listingBlocked',
    CONTACT_BLOCKED: 'contactBlocked',
  },
};

export default ListingActivationConstants;
